/* FIBER · PDP: preço com cupom já aplicado + ticket do combo + gaveta de itens · v3.2.0 · 2026-11-02 (Black: Pix 5%, selo % OFF sobre o Pix) | v3.1.0 · 2026-10-21
 * Lê window.FIBER_COMBO (snippets/fiber-combo-pdp.liquid). A página pode estar em cache: datas checadas aqui também.
 *   cupom vigente  -> mostra o bloco de preço com cupom e aplica o código (fetch /discount/CODIGO, 1x por sessão)
 *   combo vigente  -> mostra o ticket; "Ver ..." abre o <dialog> nativo com a lista da outra coleção
 * Eventos do Prestige usados: variant:change, cart:prepare-bundled-sections, cart:change, cart:refresh, theme:loading:start/end.
 */
(function () {
  'use strict';

  if (window.__fcbInit) return;
  window.__fcbInit = true;

  var cfg = window.FIBER_COMBO;
  if (!cfg || cfg.v !== 3 || !cfg.product) return;

  var I18N = cfg.i18n || {};
  var TIMEOUT_MS = 12000; // limite de cada fetch
  var DONE_MS = 2800; // quanto tempo o botão fica em "Adicionado"
  var MAX_TIMER = 2147483647; // limite do setTimeout
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var brl;
  try {
    brl = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: cfg.currency || 'BRL' });
  } catch (e) {
    brl = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  var state = { price: cfg.product.price || 0, compare: cfg.product.compareAt || 0 };

  /* ------------------------------------------------------------ helpers */
  function qsa(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function fmt(tpl, map) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) {
      return map && map[k] != null ? map[k] : m;
    });
  }

  // mesmo arredondamento do checkout (validado em 09/10): o desconto trunca o centavo
  function discounted(cents, pct) {
    return cents - Math.floor((cents * pct) / 100);
  }

  // cupom em valor fixo (amt, centavos) ou percentual (pct); nunca abaixo de zero
  function withCupom(cents) {
    if (cfg.cupom && cfg.cupom.amt > 0) return Math.max(0, cents - cfg.cupom.amt);
    return discounted(cents, cfg.cupom ? cfg.cupom.pct : 0);
  }

  function money(cents) {
    return brl.format(cents / 100);
  }

  function inWindow(w, now) {
    if (!w) return false;
    var end = Date.parse(w.end);
    if (isNaN(end) || now > end) return false;
    if (w.start) {
      var start = Date.parse(w.start);
      if (!isNaN(start) && now < start) return false;
    }
    return true;
  }

  /* ------------------------------------------------------------- cupom */
  function cupomOn(now) {
    return !!(cfg.cupom && inWindow(cfg.cupom, now));
  }

  // aplica o cupom na sessão do carrinho (o checkout recebe o código). 1x por sessão do navegador.
  var applying = false;
  function applyCupom() {
    return; // 2026-11-03: Rafael pediu sem aplicação automática; cliente ativa pelo botão
    var code = String(cfg.cupom.code).toUpperCase();
    var key = 'fcb_applied_' + code;
    try {
      if (window.sessionStorage.getItem(key)) return;
    } catch (e) {}
    if (applying) return;
    applying = true;
    fetch(root + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('status ' + r.status);
        try {
          window.sessionStorage.setItem(key, '1');
        } catch (e) {}
      })
      .catch(function () {
        // não aplicou: "já aplicado" seria mentira, esconde o bloco até a próxima tentativa
        failed = true;
        render();
      })
      .then(function () {
        applying = false;
      });
  }
  var failed = false;

  /* ------------------------------------------------------------ render */
  function parcText(cents) {
    var n = cents >= 18000 ? 3 : cents >= 12000 ? 2 : 1;
    return n > 1 ? 'em até ' + n + 'x de <b>' + money(Math.floor(cents / n)) + '</b> sem juros' : '';
  }

  function render() {
    var now = Date.now();
    var cOn = cupomOn(now) && !failed;
    var offer = document.querySelector('[data-fcb-offer]');
    if (offer) {
      offer.hidden = !(cOn && state.price > 0);
      if (!offer.hidden) {
        var fin = withCupom(state.price);
        var was = state.compare > state.price ? state.compare : state.price;
        var set = function (sel, html) {
          var el = offer.querySelector(sel);
          if (el) el.innerHTML = html;
        };
        set('[data-fcb-o-price]', money(fin));
        set('[data-fcb-o-was]', money(was));
        var p = parcText(fin);
        var pe = offer.querySelector('[data-fcb-o-parc]');
        if (pe) {
          pe.hidden = true;
        }
        set('[data-fcb-o-pix]', money(Math.round((fin * 95) / 100)));
        var pixC = Math.round((fin * 95) / 100);
        if (was > 0) set('[data-fcb-o-off]', Math.floor(((was - pixC) * 100) / was) + '% OFF');
      }
    }

    // barra fixa de compra: mesmo preço com cupom do topo (FIBER 2026-10-23)
    qsa('[data-fcb-sticky]').forEach(function (st) {
      st.hidden = !(cOn && state.price > 0);
      if (st.hidden) return;
      var sp = st.querySelector('[data-fcb-s-price]');
      var sw = st.querySelector('[data-fcb-s-was]');
      if (sp) sp.textContent = money(Math.round((withCupom(state.price) * 95) / 100));
      if (sw) sw.textContent = money(state.compare > state.price ? state.compare : state.price);
    });

    // box do Pix do tema lê o preço sem cupom: com cupom vigente, alinha o valor ao Pix do bloco de preço
    if (cOn && state.price > 0) {
      var pixTxt = money(Math.round((withCupom(state.price) * 95) / 100));
      [0, 150, 600].forEach(function (ms) {
        setTimeout(function () {
          qsa('.pdp-pix-valor').forEach(function (el) {
            if (el.textContent !== pixTxt) el.textContent = pixTxt;
          });
        }, ms);
      });
    }

    var combo = document.querySelector('[data-fcb-combo]');
    if (combo) {
      var on = !!(cfg.combo && inWindow(cfg.combo, now) && state.price > 0);
      combo.hidden = !on;
      if (!on) {
        var dlg = combo.querySelector('dialog');
        if (dlg && dlg.open) dlg.close();
      }
      var tp = combo.querySelector('[data-fcb-tprice]');
      if (tp) tp.textContent = money(discounted(state.price, cfg.combo ? cfg.combo.pct : 14));
      var lug = combo.querySelector('[data-fcb-lugar]');
      if (lug) {
        lug.hidden = !cOn;
        var lp = lug.querySelector('[data-fcb-lugar-pct]');
        if (lp && cfg.cupom) lp.textContent = cfg.cupom.label || cfg.cupom.pct + '%';
      }
    }
    document.documentElement.setAttribute('data-fcb-mode', (cOn ? 'cupom' : '') + (combo && !combo.hidden ? '+combo' : ''));
  }

  function paintItem(item) {
    var sel = item.querySelector('[data-fcb-variant]');
    var opt = sel && sel.options[sel.selectedIndex];
    var btn = item.querySelector('[data-fcb-add]');
    var price = opt ? parseInt(opt.getAttribute('data-price'), 10) : NaN;
    if (isNaN(price)) return; // item de variante única: o preço já veio pronto do Liquid
    var fin = item.querySelector('[data-fcb-final]');
    if (fin) fin.textContent = money(price); // preço normal, sem desconto (o combo não vale avulso)
    if (btn && opt) btn.setAttribute('data-variant-id', opt.value);
  }

  /* ------------------------------------------------ janela: fim automático */
  var timer = null;
  function schedule() {
    clearTimeout(timer);
    var now = Date.now();
    var next = Infinity;
    [cfg.combo, cfg.cupom].forEach(function (w) {
      if (!w) return;
      [w.start, w.end].forEach(function (iso) {
        var t = Date.parse(iso);
        if (!isNaN(t) && t > now && t < next) next = t;
      });
    });
    if (next === Infinity) return;
    timer = setTimeout(function () {
      render();
      schedule();
    }, Math.min(next - now + 250, MAX_TIMER));
  }

  /* ------------------------------------------------- variante do produto */
  document.addEventListener('variant:change', function (e) {
    var d = e.detail || {};
    if (d.product && d.product.id != null && String(d.product.id) !== String(cfg.product.id)) return;
    if (!d.variant) return;
    state.price = d.variant.price || 0;
    state.compare = d.variant.compare_at_price || 0;
    render();
  });

  /* ---------------------------------------------- variante do acessório */
  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest ? e.target.closest('[data-fcb-variant]') : null;
    if (!sel) return;
    var item = sel.closest('[data-fcb-item]');
    if (item) {
      paintItem(item);
      clearMsg(item);
      setBtn(item.querySelector('[data-fcb-add]'), 'idle');
    }
  });

  /* ------------------------------------------------- adicionar ao carrinho */
  var CHECK =
    '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" d="M3 8.5l3.2 3L13 4.5"/></svg>';

  function setBtn(btn, st) {
    if (!btn) return;
    clearTimeout(btn.__fcbT);
    btn.removeAttribute('aria-busy');
    btn.disabled = false;
    btn.classList.remove('is-done');
    if (st === 'loading') {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = I18N.adding || 'Adicionando';
    } else if (st === 'done') {
      btn.classList.remove('button--outline'); // vira botão cheio (verde de sucesso, ver CSS)
      btn.classList.add('is-done');
      btn.innerHTML = CHECK + (I18N.added || 'Adicionado');
      btn.__fcbT = setTimeout(function () {
        setBtn(btn, 'idle');
      }, DONE_MS);
    } else if (st === 'error') {
      btn.classList.add('button--outline');
      btn.textContent = I18N.retry || 'Tentar de novo';
    } else {
      btn.classList.add('button--outline');
      btn.textContent = I18N.add || 'Adicionar';
    }
  }

  function showMsg(item, text) {
    var el = item && item.querySelector('[data-fcb-msg]');
    if (!el) return;
    el.textContent = text;
    el.hidden = false;
  }

  function clearMsg(item) {
    var el = item && item.querySelector('[data-fcb-msg]');
    if (el) {
      el.textContent = '';
      el.hidden = true;
    }
  }

  // fetch com timeout; resolve {ok, status, data}. Rejeita com {timeout:true} ou erro de rede
  function request(url, opts) {
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var t = setTimeout(function () {
      if (ctrl) ctrl.abort();
    }, TIMEOUT_MS);
    opts = opts || {};
    if (ctrl) opts.signal = ctrl.signal;
    return fetch(url, opts)
      .then(function (r) {
        return r
          .json()
          .catch(function () {
            return null; // resposta que não é JSON (sessão/cache) conta como erro
          })
          .then(function (data) {
            return { ok: r.ok && data !== null, status: r.status, data: data };
          });
      })
      .catch(function (err) {
        throw { timeout: err && err.name === 'AbortError', error: err };
      })
      .then(
        function (v) {
          clearTimeout(t);
          return v;
        },
        function (e) {
          clearTimeout(t);
          throw e;
        }
      );
  }

  function addToCart(btn) {
    var item = btn.closest('[data-fcb-item]');
    var sel = item && item.querySelector('[data-fcb-variant]');
    var id = parseInt(sel ? sel.value : btn.getAttribute('data-variant-id'), 10);
    var title = btn.getAttribute('data-title') || '';
    var live = document.querySelector('[data-fcb-live]');
    var docEl = document.documentElement;

    clearMsg(item);
    if (!id) {
      setBtn(btn, 'error');
      showMsg(item, I18N.error);
      return;
    }
    setBtn(btn, 'loading');

    // contrato do ProductForm do tema: a gaveta se registra neste evento para receber o HTML da seção junto do add
    var sections = [];
    docEl.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
    docEl.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    request(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: [{ id: id, quantity: 1 }],
        sections: sections.join(','),
        sections_url: root + 'variants/' + id
      })
    })
      .then(function (added) {
        if (!added.ok) {
          var d = added.data || {};
          throw { message: d.description || d.message || I18N.error };
        }
        return request(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (c) {
          if (!c.ok) throw { message: I18N.error };
          return { added: added.data, cart: c.data };
        });
      })
      .then(function (res) {
        docEl.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        setBtn(btn, 'done');
        var dlgEl = btn.closest('dialog');
        if (dlgEl && dlgEl.open) dlgEl.close();
        if (live) live.textContent = fmt(I18N.addedLive, { title: title });

        var settings = (window.themeVariables && window.themeVariables.settings) || {};
        if (settings.cartType === 'page') {
          window.location.href = root + 'cart';
          return;
        }

        var sectionsOk =
          sections.length > 0 &&
          res.added.sections &&
          sections.every(function (k) {
            return typeof res.added.sections[k] === 'string';
          });
        var items = res.added.items || [res.added];

        if (item) item.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: items, cart: res.cart, onSuccessDo: 'force_open_drawer' } }));

        if (sectionsOk) {
          res.cart.sections = res.added.sections;
          docEl.dispatchEvent(
            new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: res.cart } })
          );
        } else {
          // sem HTML de seção na resposta: a gaveta refaz o fetch sozinha e abrimos pelo método dela
          docEl.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.show === 'function') drawer.show();
        }
      })
      .catch(function (err) {
        docEl.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        setBtn(btn, 'error');
        showMsg(item, err && err.timeout ? I18N.timeout : (err && err.message) || I18N.error);
      });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest) {
      var op = t.closest('[data-fcb-open]');
      if (op) {
        var d = op.closest('[data-fcb-combo]').querySelector('dialog');
        if (d && typeof d.showModal === 'function' && !d.open) d.showModal();
        return;
      }
      if (t.closest('[data-fcb-close]')) {
        var dd = t.closest('dialog');
        if (dd) dd.close();
        return;
      }
      if (t.tagName === 'DIALOG' && t.hasAttribute('data-fcb-dialog')) {
        t.close(); // clique no fundo (backdrop)
        return;
      }
    }
    var btn = e.target && e.target.closest ? e.target.closest('[data-fcb-add]') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();
    addToCart(btn);
  });

  /* ------------------------------------------------------------- start */
  function start() {
    render();
    if (cupomOn(Date.now())) applyCupom();
    schedule();
  }

  // página em cache/bfcache e aba aberta por horas: reavalia janela e cupom ao voltar
  window.addEventListener('pageshow', start);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) start();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
